import { Link } from 'react-router';
import { useKaannos } from '../lib/i18n';

export default function EiLoytynytSivu() {
  const { t } = useKaannos();

  return (
    <div className="py-16 text-center">
      <h1 className="text-teksti text-lg font-semibold">{t('eiLoytynyt.otsikko')}</h1>
      <p className="text-teksti-vaimea mt-2 text-sm">{t('eiLoytynyt.selite')}</p>
      <Link
        to="/kalenteri"
        className="text-korostus mt-6 inline-block text-sm font-medium hover:underline"
      >
        {t('eiLoytynyt.linkki')}
      </Link>
    </div>
  );
}
